__webpack_require__.p = "/techVictor-portfolio/";